import $x from '@/utils/$x';

// xplan栏目列表
export async function getXplanTabPageList(params) {
  return $x.post('/xplantab/getXplanTabPageList', params);
}

// 保存xplan栏目
export async function addXplanTabPage(params) {
  return $x.post('/xplantab/addXplanTabPage', params);
}

// 删除xplan栏目
export async function deleteXplanTabPage(params) {
  return $x.post('/xplantab/deleteXplanTabPage', params);
}

// 上下架xplan栏目
export async function enableOrDisableXplanTab(params) {
  return $x.post('/xplantab/enableOrDisableXplanTab', params);
}

// 修改xplan栏目
export async function updateXplanTabPage(params) {
  return $x.post('/xplantab/updateXplanTabPage', params);
}

// 栏目下的专题列表
export async function getXplanTabPageTopicList(params) {
  return $x.post('/xplantab/getXplanTabPageTopicList', params);
}

// 设置tab页和专题的关联关系
export async function addXplanTabPageTopicRel(params) {
  return $x.post('/xplantab/addXplanTabPageTopicRel', params);
}

//  解绑tab页和专题的关联关系
export async function deleteXplanTabPageTopicRel(params) {
  return $x.post('/xplantab/deleteXplanTabPageTopicRel', params);
}

//  设置xplan栏目权重
export async function setXplanTabPageWeight(params) {
  return $x.post('/xplantab/setXplanTabPageWeight', params);
}

//  栏目下专题排序权重
export async function setXplanTabPageTopicWeight(params) {
  return $x.post('/xplantab/setXplanTabPageTopicWeight', params);
}

//  查询栏目推荐位课程列表
export async function getXplanTabPageCourseList(params) {
  return $x.post('/xplantab/getXplanTabPageCourseList', params);
}

//  增加栏目推荐位课程
export async function saveXplanTabPageCourseRel(params) {
  return $x.post('/xplantab/saveXplanTabPageCourseRel', params);
}

//  删除栏目推荐位课程
export async function deleteXplanTabPageCourseRel(params) {
  return $x.post('/xplantab/deleteXplanTabPageCourseRel', params);
}

// 查询一般专题列表
export async function getXplanTopicList(params) {
  return $x.post('/xplantopic/getXplanTopicList', params);
}

// 查询一般课程列表
export async function getXplanContentPage(params) {
  return $x.post('/xplancontent/getXplanContentPage', params);
}